module.exports = __webpack_public_path__ + "static/media/12.185f529e.jpg";